<template>
  <TenantPlusExclusiveImagesModal
    :isVisible="isVisible"
    :translations="translations"
    :imageSrc="imageSrc"
    :imageAlt="imageAlt"
    :startTrialUrl="startTrialUrl"
    :learnMoreUrl="learnMoreUrl"
    :alreadyTenantPlusUserUrl="alreadyTenantPlusUserUrl"
    :modalOpenTrigger="modalOpenTrigger"
    :theme="theme"
    @close="emit('close')"
  />
</template>

<script lang="ts" setup>
import { IconTheme } from '@smg-real-estate/domus';
import { TenantPlusExclusiveImagesModal } from '@smg-real-estate/seeker-app-shared-components';

import type { TenantPlusUpsellModalTranslations } from '@/helpers/TenantPlus/buildTenantPlusUpsellTranslations';

// TODO(DOL-3786): Refactor `TenantPlusExclusiveImagesModal` in seeker-app-shared-components to use the
// shared upsell modal only, then align exclusive-images upsell usage on SRP and PDP.

defineOptions({
  name: 'TenantPlusUpsellModal',
});

interface Props {
  isVisible?: boolean;
  translations: TenantPlusUpsellModalTranslations;
  imageSrc: string;
  imageAlt?: string;
  startTrialUrl: string;
  learnMoreUrl: string;
  alreadyTenantPlusUserUrl: string;
  modalOpenTrigger: string;
  theme?: IconTheme;
}

withDefaults(defineProps<Props>(), {
  isVisible: true,
  imageAlt: 'tenant plus image',
  theme: undefined,
});

const emit = defineEmits<{
  close: [];
}>();
</script>
